import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const reasons = [{
  title: 'Keto / Ayuno Intermitente',
  description: 'Sin ajustar las hormonas base, estresan el sistema endocrino, elevan el cortisol y bloquean la quema de grasa.'
}, {
  title: 'Cardio Intenso / HIIT',
  description: 'El ejercicio de alto impacto añade leña al fuego del estrés inflamatorio. Más cortisol = más grasa abdominal.'
}, {
  title: 'Suplementos Quema Grasa',
  description: 'Sin abordar el desequilibrio hormonal de fondo, ningún suplemento puede reactivar un metabolismo bloqueado.'
}];
export function WhyItDidntWork() {
  return <section className="py-20 lg:py-32 bg-white" data-id="element-242">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-244">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2D5A34] text-center mb-12" data-id="element-245">
            ¿Por qué lo que intentaste no funcionó?
          </h2>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-12" data-id="element-246">
            {reasons.map((reason, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.1
          }} className="text-center" data-id="element-247">
                <div className="bg-red-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4" data-id="element-248">
                  <XCircleIcon className="w-10 h-10 text-red-600" data-id="element-249" />
                </div>
                <h3 className="text-xl font-bold text-[#2D2D2D] mb-3" data-id="element-250">
                  {reason.title}
                </h3>
                <p className="text-[#2D2D2D]" data-id="element-251">{reason.description}</p>
              </motion.div>)}
          </div>

          <div className="bg-[#A8D5AC]/20 rounded-2xl p-6 lg:p-8 max-w-3xl mx-auto text-center" data-id="element-252">
            <p className="text-lg text-[#2D5A34] font-semibold" data-id="element-253">
              El problema nunca fue tu disciplina. Fue que nadie te dio el
              protocolo correcto para tu nueva biología.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}